export default () => window.innerWidth < 1280
